﻿'use strict';

import './product';
